
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";

import PosMarkerData from "../a-model/posMarkerData";

@Component({
  name: "pageMapTest",
  components: {}
})
export default class PageMapTestComponent extends Vue {
  center = [47.0264, 28.8404];
  innerItems: PosMarkerData[] = [];
  innerRoute: number[][] = [];

  created() {
    document.title = this.$route.meta.title;
    this.getItems();
  }

  onDragEnd(data: { id: number; marker: PosMarkerData }) {
  }
  onMarkerClick(value: any) {
  }
  onGetCoord(value: any) {
  }
  onUpdateCoord(value: any) {
  }
  getItems() {
    this.innerItems = [];
    this.innerItems = [
      {
        id: 1,
        icon: "/assets/img/map-point.svg",
        positionPoint: { lat: 47.0264, lng: 28.8404 },
        draggable: true
      },
      {
        id: 2,
        icon: "/assets/img/map-point.svg",
        positionPoint: { lat: 47.0264, lng: 29.8604 }
      }
    ];
    this.innerRoute = [[47.0264, 28.8404], [47.0264, 29.8404]];
  }

  getStyle() {
    var style: any = {};

    style["height"] = 300 + "px";
  }
}
